


























import { Vue, Component, Prop } from 'vue-property-decorator'

export enum OzDividerColorScheme {
  Solid = 'Solid',
  Translucent = 'Translucent',
}

@Component
export default class OzDivider extends Vue {
  OzDividerColorScheme = OzDividerColorScheme

  /**
   * Dark mode
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Color scheme.
   *
   *
   * **Solid** - used in OzMenuRows
   *
   * - Light mode: divider-gray
   * - Dark mode: divider-gray-dark
   *
   *
   * **Translucent** - used in billing
   *
   * - Light mode: grey-200
   * - Dark mode: white-400
   * - Opacity: 0.3
   *
   */
  @Prop({ required: true }) colorScheme!: OzDividerColorScheme
}
